export interface AuthMethod {
  name: string
  associateUrl: string
}

export enum Tabs {
  SignIn = `sign-in`,
  Register = `register`
}
